import { PessoaRegra } from './../../model/pessoa/pessoaRegra';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { AutoRegisterService } from '../generics/servicesRegistry';

@Injectable({
  providedIn: 'root'
})

@AutoRegisterService()
export class PessoaRegraService extends GenericService<PessoaRegra>{
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("pessoaregra")
  }
}
